<div class="nav-bar">
	<div class="nav-bar-col">
		<a routerLink="/" class="icon md icon-back">
			<fa-icon [icon]="['fas','home']" size="md"></fa-icon>
		</a>
	</div>
	<div class="nav-bar-col">
		<a routerLink="/">
			<img src="assets/images/logo.png">
		</a>
	</div>
	<div class="nav-bar-col">
		<a routerLink="/" (click)="logout()" class="icon md icon-back">
			<fa-icon [icon]="['fas','sign-out-alt']" size="md"></fa-icon>
		</a>
	</div>
</div>

<div class="nav-bar-sub u-align-center">
	<ng-container *ngIf="settings.navigateToSettings">
		<div class="d-flex justify-content-center align-items-center" (click)="goToSettings()">
			<h1 class="head head1">
				{{ settings.title }}
			</h1>
			<span class="icon clean md">
				<fa-icon [icon]="['fas','cog']" size="md"></fa-icon>
			</span>
		</div>
	</ng-container>

	<ng-container *ngIf="!settings.navigateToSettings">
		<span class="icon sm icon-back" *ngIf="settings.navigateBack" (click)="goBack()">
			<fa-icon [icon]="['fas','angle-left']" size="md"></fa-icon>
		</span>
		<h1 class="head head1">{{ settings.title }}</h1>
	</ng-container>
</div>